import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SportsCacheService } from '@frontend/sports/betting-offer/feature/sports-cache';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { CountItem, isAntepost } from '@frontend/sports/common/core/data-access/sport-model';
import { getAllParams } from '@frontend/sports/common/core/utils/route-params';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { SportUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';
import { Observable, map } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SportRedirectGuard {
    private cache = inject(SportsCacheService);
    private redirectHelper = inject(RedirectHelperService);

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        if (route.firstChild) {
            return true;
        }

        const { sport, context } = getAllParams(route);
        const fallback = route.queryParams.fallback;

        return this.cache.getSport(Number(sport)).pipe(
            map((result) => {
                if (result) {
                    if (result.id === SportConstant.Golf) {
                        if (isAntepost(result)) {
                            this.redirectHelper.goToSport(result, SportUrlParam.Antepost);

                            return false;
                        }
                    }

                    if (!context && fallback) {
                        const [region, league]: CountItem[] = this.getFallback(result);

                        if (region) {
                            this.redirectHelper.goToSport(result, region, league, true);
                        } else {
                            this.redirectHelper.goToSport(result, SportUrlParam.Betting, SportUrlParam.Competitions, true);
                        }

                        return false;
                    }
                }

                return true;
            }),
        );
    }

    private getFallback(sport: CountItem): CountItem[] {
        const items = [];

        if (sport.children.length === 1) {
            items.push(sport.children[0]);

            if (sport.children[0].children.length === 1) {
                items.push(sport.children[0].children[0]);
            }
        }

        return items;
    }
}
